import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { take } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LabelCreatedRouteGuard  {
  constructor(private router: Router, private store: Store<AppState>) {}

  // eslint-disable-next-line unused-imports/no-unused-vars-ts
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let returnOrder: any;
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        returnOrder = ro;
      });
    if (returnOrder && returnOrder.label && returnOrder.label.isComplete) {
      // Label already created, show errors
      const parent = next.parent.routeConfig.path;
      return this.router.parseUrl(`${parent}/error`);
    }
    return true;
  }
}
